import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { observer } from "mobx-react-lite";
import { HowItWorks } from "../components/HowItWorks";
import { GetStarted } from "../components/GetStarted";
import { StateService } from "../services/StateService";
import { HeroSection } from '../components/HeroSection';
import leftCardImg from '../assets/auction-img-left.png';
import rightCardImg from '../assets/auction-img-right.png';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    paddingTop: '0px',
    maxWidth: '1400px',
    margin: '0 auto',
    paddingBottom: '150px',
  },
  countDown: {
    width: '100%',
    color: 'white',
    borderRadius: '20px',
    marginTop: '6.5rem',
  },
  countDownTime: {
    width: '98%',
    margin: '0 auto',
    marginTop: '20px',
    paddingBottom: '15px',
    position: 'relative',
  },
  cardSection: {
    marginTop: '0px',
    flexGrow: 1,
    width: '100%',
  },
  leftLayout: {
    position: 'absolute',
    width: '516px',
    height: '425px',
    left: '-32px',
    bottom: '211px',
    background: 'linear-gradient(199.55deg, rgba(72, 46, 95, 0.225033) 40.83%, #503045 105.46%)',
    mixBlendMode: 'normal',
    opacity: '0.9',
    filter: 'blur(135.914px)',
  },
  rightLayout: {
    position: 'absolute',
    width: '376px',
    height: '384px',
    right: '29px',
    top: '6px',
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
    transform: 'rotate(90deg)',
  },
  bottomLayout: {
    position: 'absolute',
    width: '331px',
    height: '209px',
    right: '-156px',
    bottom: 0,
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
  },
  innerLay: {
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  innerLay1: {
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
}));

interface AboutPageProps {
  state: StateService;
}

function getCountdownDate(state: StateService): Date | undefined {
  let activeRound = state.rounds.getActiveRound();

  // need to set a date in the past or the timer will freeze
  let dateInPast = '2021-07-09T00:00:00.000Z';

  if (activeRound === "done"){
    return new Date(dateInPast);
  }

  return state.rounds.getPhaseEndTime(activeRound);
}

// Function to convert round info to page name
function getPage(currentRound: string): string {

  let ret = "";

  switch (currentRound) {
    case "auction":
      ret = "auction";
      break;
    case "entropy":
      ret = "build";
      break;
    case "voting1":
    case "voting2":
    case "voting3":
      ret = "voting";
      break;
    case "done":
      ret = "winners";
      break;
  }

  return ret;
}


function getHeroTitle(currentRound: string): string {
  if(currentRound === "build" || currentRound === "voting") {
    return `${currentRound.toUpperCase()} CLOSES IN`;
  }

  if(currentRound === "auction") {
    return "AUCTION SLOTS REMAINING";
  }

  return "COLEARN pAInt IS FINISHED";
}


export const AboutPage = observer((props: AboutPageProps)  => {
  const classes = useStyles();
  let activeRound = getPage(props.state.rounds.getActiveRound());
  let title = getHeroTitle(activeRound);

  return (
    <div className={classes.root}>
      <div className={classes.countDown}>
        <div className={classes.countDownTime}>
          <div className={classes.leftLayout}></div>
          <div className={classes.rightLayout}>
            <div className={classes.innerLay}>
            </div>
            <div className={classes.innerLay1}></div>
          </div>
          <HeroSection
            title={title}
            state={props.state}
            countDownDate={getCountdownDate(props.state)}
            leftCardImg={leftCardImg}
            rightCardImg={rightCardImg}
            isDone={props.state.rounds.isDonePhase()}
            isAuction={props.state.rounds.isAuctionPhase()}
          />
        </div>
      </div>
      <div className={classes.cardSection}>
        <Grid container style={{ position: 'relative' }}>
          <HowItWorks state={props.state} />
        </Grid>
      </div>

      <div className={classes.cardSection}>
        <Grid container style={{ position: 'relative' }}>
          <GetStarted />
        </Grid>
      </div>
    </div>
  );
});
